module.exports = __webpack_public_path__ + "img/green-carpet-grass-00.3931465a.png";